// extracted by mini-css-extract-plugin
module.exports = {"maxWidth":"MaxWidth_maxWidth__2M4Lk","limited":"MaxWidth_limited__tiohk","mobile_wide":"MaxWidth_mobile_wide__cMjRw"};